var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "app-main-inner app-main-page",
      staticStyle: { height: "auto" }
    },
    [
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "0", "padding-bottom": "0" }
        },
        [_vm._v(_vm._s(_vm.$t("Partners.mergedPartners")) + "：")]
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row",
          staticStyle: { "padding-top": "0", "padding-bottom": "0" }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", width: "100%" } },
            [
              _c("el-input", {
                staticStyle: { width: "50%", "padding-right": "10px" },
                attrs: {
                  no: "inputCompanyName",
                  placeholder: _vm.$t("common.tips.fuzzySearch")
                },
                model: {
                  value: _vm.inputCompanyName,
                  callback: function($$v) {
                    _vm.inputCompanyName = $$v
                  },
                  expression: "inputCompanyName"
                }
              }),
              _c(
                "el-button",
                {
                  attrs: { no: "onInput", type: "primary" },
                  on: { click: _vm.onInput }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.query")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid",
          staticStyle: { "min-height": "333px" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "side-bar": _vm.sideBarDefs,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: { gridReady: _vm.onGridReady }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-pagination",
          staticStyle: { "padding-right": "0px" }
        },
        [
          _c("cargo-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0"
              }
            ],
            attrs: {
              total: _vm.total,
              page: _vm.filter.pageNum,
              limit: _vm.filter.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.filter, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.filter, "pageSize", $event)
              },
              pagination: _vm.toQuery
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }